module.exports = __webpack_public_path__ + "assets/arcadeweb.png?150f3605b6ad6957375d8a4a8cfe5d07";